module.exports = __webpack_public_path__ + "videos/24.ced0bfb.mp4";